import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 12h-5","key":"svg-0"}],["path",{"d":"M2 9h5","key":"svg-1"}],["path",{"d":"M2 15h5","key":"svg-2"}],["path",{"d":"M7 5l10 7l-10 7l0 -14","key":"svg-3"}]]

const IconLogicBuffer = createReactComponent('outline', 'logic-buffer', 'LogicBuffer', __iconNode);

export default IconLogicBuffer;